import { useEvent, useRingSettings } from '@bizzabo/entities';

/**
 * Query the status of a feature controlled by the Bizzabo dashboard
 * @param eventUniqueName Event unique name
 * @param ringFeatureName Bizzabo dashboard feature toggle name
 */
const useRingFeature = (eventUniqueName: string, ringFeatureName: string) => {
    const { data: event, isLoading: isLoadingEvent } = useEvent(eventUniqueName);
    const {
        data: ringSettings,
        isLoading: isLoadingRingSettings,
        isIdle: isSettingsQueryIdle,
    } = useRingSettings(event?.id, event?.accountId, {
        enabled: !!event,
        retry: 1,
    });

    return {
        data: ringSettings?.['features']?.[ringFeatureName],
        isLoading: isLoadingEvent || isLoadingRingSettings || isSettingsQueryIdle,
    };
};

export default useRingFeature;
